import { render, staticRenderFns } from "./AngkasaReport.vue?vue&type=template&id=2e7333e6"
import script from "./AngkasaReport.vue?vue&type=script&lang=js"
export * from "./AngkasaReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports